const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

export const isGoogleAnalyticsEnabled = () => Boolean(MEASUREMENT_ID);

export const initGoogleAnalytics = () => {
    if (!isGoogleAnalyticsEnabled() || window.gtag) {
        return;
    }

    window.dataLayer = window.dataLayer || [];
    window.gtag = function gtag() {
        window.dataLayer.push(arguments);
    };
    window.gtag("js", new Date());
    window.gtag("config", MEASUREMENT_ID, {send_page_view: false});

    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
    document.head.appendChild(script);
};

export const trackPageView = (path) => {
    if (!isGoogleAnalyticsEnabled() || typeof window.gtag !== "function") {
        return;
    }

    window.gtag("event", "page_view", {
        page_path: path,
        page_location: `${window.location.origin}${path}`,
        page_title: document.title,
    });
};